import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, userData, error } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/" replace />;

  // Authenticated but profile failed to load — don't silently grant full access.
  // This prevents an expired-trial user from bypassing the trial check when
  // their Firestore profile document couldn't be read.
  if (!userData) {
    return (
      <div className="loading-container">
        <p style={{ color: 'var(--text-secondary)', marginBottom: 12 }}>
          {error ? "We couldn't load your profile. Please refresh the page." : 'Loading your profile…'}
        </p>
        {error && (
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 20px', borderRadius: 8, border: 'none',
              background: 'var(--brand)', color: '#fff', cursor: 'pointer',
              fontFamily: 'inherit', fontSize: 14,
            }}
          >
            Refresh
          </button>
        )}
      </div>
    );
  }

  // Trial expiration lockout disabled for now — see conversation with Mackayla, 2026-07-21.
  // Re-enable by uncommenting below.
  // if (userData.accountType === 'trial' && userData.trialExpiresAt) {
  //   const exp = userData.trialExpiresAt?.toDate?.() ?? new Date(userData.trialExpiresAt);
  //   if (exp < new Date()) return <Navigate to="/?trialExpired=true" replace />;
  // }

  return children;
};
